import { render, staticRenderFns } from "./LabelTag.vue?vue&type=template&id=5181b84d&scoped=true&"
import script from "./LabelTag.vue?vue&type=script&lang=js&"
export * from "./LabelTag.vue?vue&type=script&lang=js&"
import style0 from "./LabelTag.vue?vue&type=style&index=0&id=5181b84d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5181b84d",
  null
  
)

export default component.exports